const lifelineCdnBase = 'https://cdn.grofers.com/assets/web/lifeline';
export const smallRider = `${lifelineCdnBase}/rider-small.png`;
export const riderScooter = `${lifelineCdnBase}/scooter.png`;
export const homePageImg = `${lifelineCdnBase}/telescope.png`;
export const timer = `${lifelineCdnBase}/timer.png`;
export const lifelineLogo = `${lifelineCdnBase}/lifeline-logo.png`;
export const kick = `${lifelineCdnBase}/kick.jpeg`;
export const grocery = `${lifelineCdnBase}/grocery.png`;
export const deliveryBoy = `${lifelineCdnBase}/delivery-boy.png;`;
export const mapRider = `${lifelineCdnBase}Map-rider.png`;
export const allOk = `${lifelineCdnBase}All-ok.png`;

export const ZomatoLogo =
  'https://b.zmtcdn.com/data/o2_assets/2ba8f99c0a1892eed2e6f618b110e8831583304978.png';
export const ZomatoAlcoLogo =
  'https://b.zmtcdn.com/data/o2_assets/0ef11899e74b755541c20e97f1530e271589548640.png';
export const ZomatoHelpLogo =
  'https://b.zmtcdn.com/data/o2_assets/5485cd39cfa072bdf80c2dc81250c6eb1634025113.png';
// 'https://b.zmtcdn.com/data/o2_assets/4aba090ff47eaa0fb57ed7995d1104671573024523.png';
export const InvalidSearchImg = `${lifelineCdnBase}/something-went-wrong.png`;
// 'https://b.zmtcdn.com/data/o2_assets/0e84a199f8396aee36c67cad776d332a1573106533.png';
export const nonLogsBgImg =
  'https://b.zmtcdn.com/data/o2_assets/eb6f05f6ac1ee243ce615c31ee57634a1575030814.png';
export const nonLogsRider =
  'https://b.zmtcdn.com/data/o2_assets/1dba6b8b5475b054e1edc6707164f4f11575030794.png';
export const noAmbulance = 
  'https://cdn.grofers.com/layout-engine/2025-01/LL-Doc.png'
export const downTriangle =
  'https://b.zmtcdn.com/data/o2_assets/41b6af07c7c5991b6f7421eb289f72311575461451.png';
export const upArrowIcon =
  'https://b.zmtcdn.com/data/o2_assets/3164696e3edf3f199b395fca1b9fb5c51579859090.png';
export const upArrowIconGreen =
  'https://b.zmtcdn.com/data/o2_assets/80322117a31e1ed669e237fe5fab5b471581601047.png';
export const infoIcon =
  'https://b.zmtcdn.com/data/o2_assets/184c4d6ce67d5c7c888e596e323763671579859153.png';
export const seenIcon =
  'https://b.zmtcdn.com/data/o2_assets/987340f7afc8c9af7b8f535392a1d92a1580459354.png';
export const defaultIssueImg =
  'https://b.zmtcdn.com/data/o2_assets/6ff681bfe616f5e384b1fd9f099e16741581503167.png';
export const singleTick =
  'https://b.zmtcdn.com/data/o2_assets/7038233241370be1c83aaca3dc5ba4ac1581575453.png';
export const doubleTick =
  'https://b.zmtcdn.com/data/o2_assets/b6c6a4bd93f95b9cda14bd951e8271061581575433.png';
export const kebabMenuIcon =
  'https://b.zmtcdn.com/data/o2_assets/738a1d5385059d3afcd8314fdf431dca1581945634.png';
export const highAddressIcon =
  'https://b.zmtcdn.com/data/o2_assets/60c7a595941aa14d2966a5057af3ca061583138921.png';
export const lowAddressIcon =
  'https://b.zmtcdn.com/data/o2_assets/32d3111143ab9ebf50f363473f651e821582801292.png';
export const viewText =
  'https://b.zmtcdn.com/data/o2_assets/63f98e053b51d4395602c090f4c8c3de1584704008.png';
export const backArrow =
  'https://b.zmtcdn.com/data/o2_assets/6ae9118c487d2a5ec6ed7cf5587599c71584547865.png';
export const noValetAssigned =
  'https://b.zmtcdn.com/data/o2_assets/355768191ee861a6449c12f38ebd61981585907943.png';
export const blackNextArrow =
  'https://b.zmtcdn.com/data/o2_assets/73d231e77f0ef27456975b0b720b57d71592896940.png';
export const dot =
  'https://b.zmtcdn.com/data/o2_assets/3938a469f589504f19093387dfcb11201604930132.png';
export const lowBattery =
  'https://b.zmtcdn.com/data/o2_assets/7322ff9a8b1fc0347312489f83db91dc1614343302.png';
export const chargedBattery =
  'https://b.zmtcdn.com/data/o2_assets/eccc5a649339b893df3a9191bb77aef11614343383.png';
export const noRiderImage =
  'https://b.zmtcdn.com/data/o2_assets/6118c1723a20b7b59eb05171761fa89f1615792106.png';
export const priorityTag =
  'https://b.zmtcdn.com/data/o2_assets/b8e53b61ac187896b67061daf3f1b5591617772070.png';
export const autoResoveTimer =
  'https://b.zmtcdn.com/data/o2_assets/64fe5cf32c46137b257c9d38adc8e8981634901472.png';
export const feedback =
  'https://b.zmtcdn.com/data/o2_assets/b675aa97064555c6f89c64eae44a41bc1618481213.png';
export const riderDefault =
  'https://b.zmtcdn.com/data/o2_assets/cc0687a9fe0d9bb455ec28d829d22c871632061976.png';
export const resDefault =
  'https://b.zmtcdn.com/data/o2_assets/8e3a4191d18870cf7f969dd616313c901632062007.png';
export const help =
  'https://b.zmtcdn.com/data/o2_assets/6e7285ac45e113b6148d505ab41a8d3a1630486624.png';
export const rider =
  'https://b.zmtcdn.com/data/o2_assets/70100e53616ac41d38a9ed8d78ed216f1643103120.png';
export const buddyRider =
  'https://b.zmtcdn.com/data/o2_assets/66cf8efb3194c6725d651792f3177d671643103141.png';
export const headPhone =
  'https://b.zmtcdn.com/data/o2_assets/8d580b183a8c7e7b3494e44ff8aaa31f1635771434.png';
export const ZLogoBlack =
  'https://b.zmtcdn.com/web_assets/b40b97e677bc7b2ca77c58c61db266fe1603954218.png';
export const sopAssistantImg =
  'https://cdn.grofers.com/layout-engine/v2/2025-04/001.png';
